var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        { attrs: { "align-center": "", "justify-center": "", row: "" } },
        [
          _c(
            "image-input",
            {
              on: { input: _vm.updateAvatar },
              model: {
                value: _vm.image,
                callback: function($$v) {
                  _vm.image = $$v
                },
                expression: "image"
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "activator" }, slot: "activator" },
                [
                  !_vm.imageSet
                    ? _c(
                        "v-avatar",
                        {
                          directives: [{ name: "ripple", rawName: "v-ripple" }],
                          staticClass: "grey lighten-3 mb-3",
                          attrs: { size: "150px", tile: true }
                        },
                        [_c("span", [_vm._v("Click to Add a Picture")])]
                      )
                    : _c(
                        "v-avatar",
                        {
                          directives: [{ name: "ripple", rawName: "v-ripple" }],
                          staticClass: "mb-3",
                          attrs: { size: "150px", tile: true }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.image.imageURL, alt: "avatar" }
                          })
                        ]
                      ),
                  _vm._v(" "),
                  _vm.errorMsg !== ""
                    ? _c(
                        "div",
                        { staticClass: "v-messages theme-light error--text" },
                        [
                          _vm._v(
                            "\n        " + _vm._s(_vm.errorMsg) + "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a8d3d98", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a8d3d98","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/uploader/imageUploader.vue
// module id = null
// module chunks = 